<ng-container *ngIf="enabled != null; else noOption">
  <span>
    <mat-checkbox disableRipple [color]=" enabled ?  'primary': '' " [checked]="enabled" name="check">
      {{''}}
    </mat-checkbox>
  </span>

</ng-container>

<ng-template #noOption>
  <span> {{ 'common.noItem' | translate }} </span>
</ng-template>